(() => {
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const summary = nav.querySelector('summary');
  const close = nav.querySelector('[data-mobile-nav-close]');
  const setState = (open) => {
    document.body.classList.toggle('ma-mobile-nav-open', open);
    if (summary) summary.setAttribute('aria-expanded', String(open));
  };
  nav.addEventListener('toggle', () => setState(nav.open));
  close?.addEventListener('click', () => { nav.open = false; summary?.focus(); });
  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { nav.open = false; }));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && nav.open) { nav.open = false; summary?.focus(); }
  });
  document.addEventListener('click', (event) => {
    if (!nav.open || nav.contains(event.target)) return;
    nav.open = false;
  });
})();
